import { render, staticRenderFns } from "./ForumPost.vue?vue&type=template&id=1cc10f6e&scoped=true&"
import script from "./ForumPost.vue?vue&type=script&lang=js&"
export * from "./ForumPost.vue?vue&type=script&lang=js&"
import style0 from "./ForumPost.vue?vue&type=style&index=0&id=1cc10f6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc10f6e",
  null
  
)

export default component.exports